module.exports = __webpack_public_path__ + "img/sculpt2_thumb.d7b98afc.jpg";